module.exports = __webpack_public_path__ + "img/最具影响力教育品牌@2x.fa6c3ce2.png";